var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"action":"https://script.google.com/macros/s/AKfycbzqQm9pFq2gf4e-qsIgC11NJ9eeVA82o_C3cQ87JlHfz_HxujiStfMJoaMbPpT57q5u/exec","method":"post"}},[_vm._v(" "+_vm._s(_vm.$t('Report'))+" "),_c('Report')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }